import { Card, Col, Divider, Row, Typography } from 'antd';
import React, { useState } from 'react';
import UserForm from './UserForm';
import UserList from './UserList';
import './UserStyles.css';

const { Title } = Typography;

const UserManagement = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const [selectedUser, setSelectedUser] = useState(null);
    const isMobile = window.innerWidth < 768;

    // Esta función se ejecutará cuando se agregue un nuevo usuario
    const handleUserAdded = () => {
        // Incrementar el key para forzar la actualización de la lista de usuarios
        setRefreshKey(prevKey => prevKey + 1);
    };

    // Esta función se ejecutará cuando se edite un usuario
    const handleUserEdited = (user) => {
        setSelectedUser(user);
    };

    // Esta función se ejecutará cuando se actualice un usuario
    const handleUserUpdated = () => {
        // Limpiar el usuario seleccionado e incrementar el key para actualizar la lista
        setSelectedUser(null);
        setRefreshKey(prevKey => prevKey + 1);
    };

    return (
        <div className="user-management-container">
            <Title level={2}>{isMobile ? 'Usuarios' : 'Gestión de Usuarios'}</Title>
            <Divider />

            <Row gutter={[24, 24]}>
                <Col xs={24} lg={12}>
                    <Card>
                        <UserForm
                            onUserAdded={handleUserAdded}
                            onUserUpdated={handleUserUpdated}
                            userToEdit={selectedUser}
                        />
                    </Card>
                </Col>

                <Col xs={24} lg={12}>
                    <UserList
                        refreshTrigger={refreshKey}
                        onEditUser={handleUserEdited}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default UserManagement; 